import React, { useState } from 'react';
import { get_api_url } from '../../../../utils/urls';
import { post_api } from '../../../../redux/api_funcs';
// import Toast from '../../../util_components/success_toast';

function CancelPopup({ onClose, loadStudentData }: { onClose: () => void }) {
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const initialUUID = params?.get('id') || '';

  const [cancellationReason, setCancellationReason] = useState<string>('');
  const [cancellationFeedback, setCancellationFeedback] = useState<string>('');
  //   const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const handleSubmit = async () => {
    const apiUrl = await get_api_url('cancel_membership_immediately');

    const payload = {
      student_uuid: initialUUID,
      cancellation_other_reason: cancellationReason,
      cancellation_feedback: cancellationFeedback
    };

    try {
      const response = await post_api(apiUrl, payload, true);
      if (response.data.status === 'success') {
        console.log('Cancellation Successful:', response);
        alert('Cancellation Successful');
        loadStudentData();
        onClose();
        // setToast({ type: 'success', message: 'Cancellation Successful' });
      }
    } catch (error) {
      console.error('Cancellation Failed:', error);
      alert('Cancellation Failed');
      //   setToast({ type: 'error', message: 'Cancellation Failed' });
    }
  };

  return (
    <div>
      {/* {toast && <Toast type={toast.type} message={toast.message} />} */}
      <div className="mb-6">
        <label className="block font-bold mb-1" style={{ textTransform: 'unset' }}>
          Cancellation Reason <span className="text-red-500">*</span>
        </label>
        <textarea
          value={cancellationReason}
          onChange={(e) => setCancellationReason(e.target.value)}
          className="h-[100px] w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2"
          rows={4}
          placeholder="Please provide the reason for cancelling the student membership..."
        />
        <p className="text-xs text-gray-500 mt-1">
          Please help us understand why the student is cancelling
        </p>
      </div>

      <div className="mb-6">
        <label className="block font-bold mb-1" style={{ textTransform: 'unset' }}>
          Cancellation Feedback
        </label>
        <textarea
          value={cancellationFeedback}
          onChange={(e) => setCancellationFeedback(e.target.value)}
          className="h-[100px] w-full border border-gray-300 rounded-lg p-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-gray-300"
          rows={4}
          placeholder="Any additional feedback or suggestions for improvement..."
        />
        <p className="text-xs text-gray-500 mt-1">
          Optional: Share student experience to help us improve our service
        </p>
      </div>

      <div className="bg-red-100 border border-red-300 text-red-700 p-4 rounded-md text-sm flex gap-[10px]">
        <div className="h-[20px] w-[35px] rounded-full border border-red-600 flex items-center justify-center text-[12px]">
          ❗
        </div>
        <div>
          <div className="font-semibold mb-1">Important Notice</div>
          <p className="my-[5px]">
            Once this immediate cancellation request is submitted, the student membership will be
            processed for termination. This action may not be reversible.
          </p>
        </div>
      </div>

      <div className="flex justify-center gap-4 py-6">
        <button
          onClick={onClose}
          className="bg-gray-200 text-black px-6 py-2 w-full rounded border border-gray-400 hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={!cancellationReason}
          className={`px-6 py-2 w-full rounded border text-white 
            ${
              !cancellationReason
                ? 'bg-red-600 border-red-700 opacity-60 cursor-not-allowed'
                : 'bg-red-600 border-red-700 hover:bg-red-700 cursor-pointer'
            }`}
        >
          Submit Cancellation
        </button>
      </div>
    </div>
  );
}

export default CancelPopup;
